/*
  S3CTOR 地區系統 v4：這一支是「這個訪客在哪一國、看哪一種幣別、走哪一個結帳出口」
  的唯一出處。綁在一起是刻意的——分開寫遲早出現「畫面是美金、按鈕卻是台灣匯款頁」
  這種各自為政的組合，而那不會報錯。

  2026-08-28 V 定版：**逛的時候零打擾，問題只在結帳前問一次。**
    - 全站一律英文介面。不再有語言建議卡、不再有頁首地區鈕、主畫面什麼都不問。
      （台灣的結帳頁本身維持中文——超商與轉帳的說明給台灣客人本來就該中文。）
    - 按下結帳 →「SHIP TO」確認一步：預先猜好國家、一鍵繼續、記住上次的選擇
      → 台灣進匯款頁、其他國家進該國市場的 Shopify 結帳。
    - 匯款頁保留自我防衛（guardRemit）：路由永遠可能被繞過（直接連結、上一頁、
      書籤、頁面快取），非台灣的人在那一頁看不到 LINE Pay。

  歷史教訓（一個都不准回退）：
    - 判斷放瀏覽器不放 Liquid：整頁快取會把某一國的 HTML 發給下一個人，時區不會。
    - 安全預設是台灣：JS 掛掉＝台灣客人看到今天的樣子，一個字不變。
    - 監聽全部接好才 appendChild：順序反過來，中途一出錯就是按不掉的透明遮罩。
    - reveal() 絕不往外丟例外（它壞過兩次，代價是整頁點不動）。
    - 寫 textContent 就是 childList 變動，MutationObserver 在聽——先比對再寫。
*/
(function () {
  'use strict';

  var EU = ['AT', 'BE', 'CZ', 'DE', 'DK', 'ES', 'FI', 'FR', 'IE', 'IT', 'NL', 'PL', 'PT', 'SE'];
  var CKEY = 's3ctor_currency';
  var DKEY = 's3ctor_dest';

  /* 市場路徑。TW 不在這裡，它走自己的匯款頁。 */
  var MKT = { us: '/en-us', gb: '/en-gb', eu: '/en-eu', intl: '/en-intl' };

  /*
    [代碼, 英文名, 中文名, 市場]；市場為空字串的是分組標題。
    清單＝Shopify 運送區實際涵蓋的 29 國。**只列寄得到的**——列一個寄不到的，
    客人會填完整張表才在結帳頁被打回。加國家＝先去後台運送區加，再回來加這裡。
  */
  var SHIP = [
    ['NA', 'North America', '北美', ''],
    ['US', 'United States', '美國', 'us'],
    ['CA', 'Canada', '加拿大', 'intl'],
    ['EUG', 'Europe', '歐洲', ''],
    ['GB', 'United Kingdom', '英國', 'gb'],
    ['IE', 'Ireland', '愛爾蘭', 'eu'],
    ['FR', 'France', '法國', 'eu'],
    ['DE', 'Germany', '德國', 'eu'],
    ['IT', 'Italy', '義大利', 'eu'],
    ['ES', 'Spain', '西班牙', 'eu'],
    ['PT', 'Portugal', '葡萄牙', 'eu'],
    ['NL', 'Netherlands', '荷蘭', 'eu'],
    ['BE', 'Belgium', '比利時', 'eu'],
    ['AT', 'Austria', '奧地利', 'eu'],
    ['CZ', 'Czechia', '捷克', 'eu'],
    ['PL', 'Poland', '波蘭', 'eu'],
    ['DK', 'Denmark', '丹麥', 'eu'],
    ['SE', 'Sweden', '瑞典', 'eu'],
    ['FI', 'Finland', '芬蘭', 'eu'],
    ['NO', 'Norway', '挪威', 'intl'],
    ['CH', 'Switzerland', '瑞士', 'intl'],
    ['APG', 'Asia Pacific', '亞太', ''],
    ['TW', 'Taiwan', '台灣', 'tw'],
    ['HK', 'Hong Kong SAR', '香港', 'intl'],
    ['JP', 'Japan', '日本', 'intl'],
    ['KR', 'South Korea', '韓國', 'intl'],
    ['SG', 'Singapore', '新加坡', 'intl'],
    ['MY', 'Malaysia', '馬來西亞', 'intl'],
    ['AU', 'Australia', '澳洲', 'intl'],
    ['NZ', 'New Zealand', '紐西蘭', 'intl'],
    ['MEG', 'Middle East', '中東', ''],
    ['AE', 'United Arab Emirates', '阿聯酋', 'intl'],
    ['IL', 'Israel', '以色列', 'intl']
  ];

  /* 時區 → 國家。只列寄得到的；認不出來的退回 US（主打市場），不要退台灣——
     會把外國人送進匯款頁。 */
  var TZC = {
    'Asia/Taipei': 'TW', 'Asia/Hong_Kong': 'HK', 'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR',
    'Asia/Singapore': 'SG', 'Asia/Kuala_Lumpur': 'MY', 'Asia/Kuching': 'MY',
    'Asia/Dubai': 'AE', 'Asia/Jerusalem': 'IL', 'Asia/Tel_Aviv': 'IL',
    'Europe/London': 'GB', 'Europe/Dublin': 'IE', 'Europe/Paris': 'FR',
    'Europe/Berlin': 'DE', 'Europe/Busingen': 'DE', 'Europe/Rome': 'IT',
    'Europe/Madrid': 'ES', 'Africa/Ceuta': 'ES', 'Atlantic/Canary': 'ES',
    'Europe/Lisbon': 'PT', 'Atlantic/Madeira': 'PT', 'Atlantic/Azores': 'PT',
    'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Vienna': 'AT',
    'Europe/Prague': 'CZ', 'Europe/Warsaw': 'PL', 'Europe/Copenhagen': 'DK',
    'Europe/Stockholm': 'SE', 'Europe/Helsinki': 'FI', 'Europe/Oslo': 'NO',
    'Europe/Zurich': 'CH', 'Pacific/Auckland': 'NZ', 'Pacific/Chatham': 'NZ'
  };
  /* 加拿大與美國都是 America/*，加拿大要明列，其餘 America/* 才當美國。 */
  var CA_TZ = ['America/Toronto', 'America/Vancouver', 'America/Edmonton', 'America/Winnipeg',
               'America/Halifax', 'America/St_Johns', 'America/Regina', 'America/Moncton',
               'America/Whitehorse', 'America/Yellowknife'];

  /* ── 基礎判斷 ───────────────────────────────────────────── */

  function tz() {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  }

  function langCountry() {
    var l = (navigator.language || '').toUpperCase();
    var m = l.match(/-([A-Z]{2})$/);
    return m ? m[1] : '';
  }

  function ship() {
    var out = {};
    for (var i = 0; i < SHIP.length; i++) if (SHIP[i][3]) out[SHIP[i][0]] = SHIP[i][3];
    return out;
  }

  function nameOf(code, zh) {
    for (var i = 0; i < SHIP.length; i++) if (SHIP[i][0] === code) return zh ? SHIP[i][2] : SHIP[i][1];
    return code;
  }

  function guessCountry() {
    var ok = ship(), z = tz();
    if (z) {
      if (TZC[z] && ok[TZC[z]]) return TZC[z];
      if (CA_TZ.indexOf(z) > -1) return 'CA';
      if (z.indexOf('America/') === 0 || z === 'Pacific/Honolulu') return 'US';
      if (z.indexOf('Australia/') === 0) return 'AU';
    }
    var l = langCountry();
    if (l && ok[l]) return l;
    return 'US';
  }

  function get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function storedCountry() {
    var v = get(DKEY);
    return v && ship()[v] ? v : '';
  }

  function activeCountry() { return storedCountry() || guessCountry(); }

  /* /zh 已經沒有入口（V 定：全站英文），但路徑還活著——直接連結進來的人照樣要能買 */
  function pageZh() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0;
  }

  /* ── 幣別 ───────────────────────────────────────────────── */

  function defaultCurrency() {
    var c = activeCountry();
    if (c === 'TW') return 'TWD';
    if (c === 'GB') return 'GBP';
    if (EU.indexOf(c) > -1) return 'EUR';
    return 'USD';
  }

  function storedCurrency() {
    var v = get(CKEY);
    return ['USD', 'GBP', 'EUR', 'TWD'].indexOf(v) > -1 ? v : '';
  }

  var active = storedCurrency() || defaultCurrency();

  function paint(cur) {
    var sets = document.querySelectorAll('[data-s3fx]');
    for (var i = 0; i < sets.length; i++) {
      var cells = sets[i].querySelectorAll('[data-cur]');
      for (var j = 0; j < cells.length; j++) cells[j].hidden = cells[j].getAttribute('data-cur') !== cur;
    }
    var chips = document.querySelectorAll('[data-s3cur]');
    for (var k = 0; k < chips.length; k++) {
      chips[k].setAttribute('aria-pressed', chips[k].getAttribute('data-s3cur') === cur ? 'true' : 'false');
    }
    var notes = document.querySelectorAll('[data-s3fx-note]');
    for (var n = 0; n < notes.length; n++) notes[n].hidden = (cur === 'TWD');
    document.documentElement.setAttribute('data-s3-currency', cur);
  }

  /* ── 結帳出口 ───────────────────────────────────────────── */

  /* tw 那顆＝唯一的通用結帳鈕，永遠露出；intl 那顆永遠藏著只當網址載體。
     JS 掛掉＝通用鈕直通台灣匯款頁＝安全預設。 */
  function routeCheckout() {
    var twNow = activeCountry() === 'TW';
    document.documentElement.setAttribute('data-s3-intl', twNow ? 'false' : 'true');
    var a = document.querySelectorAll('[data-s3-exit="tw"]');
    for (var i = 0; i < a.length; i++) a[i].hidden = false;
    var b = document.querySelectorAll('[data-s3-exit="intl"]');
    for (var j = 0; j < b.length; j++) b[j].hidden = true;
  }

  /*
    把客人選的國家真的告訴 Shopify，再導去結帳。
    不能只導到市場路徑：/en-eu/cart/checkout 的國家欄預設是該市場第一個國家
    （實測選德國卻預設奧地利）。官方 localization 表單四個隱藏欄位一個都不能少；
    同一組參數用 curl 打會回 404——那是它要瀏覽器的表單環境，不是端點壞了。
  */
  function goCountry(code, path) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.style.display = 'none';
    var data = {
      form_type: 'localization', utf8: '✓', _method: 'put',
      country_code: code, return_to: path + '/cart/checkout'
    };
    for (var k in data) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = data[k];
      f.appendChild(i);
    }
    document.body.appendChild(f);
    f.submit();
  }

  function destination() {
    var c = activeCountry();
    return { code: c, tw: c === 'TW', path: c === 'TW' ? '' : (MKT[ship()[c]] || MKT.intl) };
  }

  /* ── 淡入（壞過兩次的那支，絕不往外丟例外） ─────────────── */

  function reveal(el) {
    try { requestAnimationFrame(function () { el.classList.add('is-in'); }); } catch (e) { el.classList.add('is-in'); }
    try { setTimeout(function () { el.classList.add('is-in'); }, 60); } catch (e) {}
  }

  /* ── 樣式 ───────────────────────────────────────────────── */

  var CSS =
    /* SHIP TO 確認層：白紙、直角、只有一條底線，黑色只給主要動作 */
    '#s3dest{position:fixed;inset:0;z-index:99999;display:flex;align-items:flex-end;justify-content:center;}' +
    '#s3dest .s3d__scrim{position:absolute;inset:0;background:rgba(10,10,10,.4);opacity:0;' +
    'transition:opacity .32s cubic-bezier(.16,1,.3,1);backdrop-filter:blur(4px);}' +
    '#s3dest .s3d__sheet{position:relative;background:#fff;color:#0A0A0A;' +
    'width:min(430px,100vw);padding:30px 26px 26px;' +
    'opacity:0;transform:translateY(16px);' +
    'transition:opacity .38s cubic-bezier(.16,1,.3,1),transform .38s cubic-bezier(.16,1,.3,1);}' +
    '#s3dest.is-in .s3d__scrim{opacity:1;}' +
    '#s3dest.is-in .s3d__sheet{opacity:1;transform:none;}' +
    '#s3dest .s3d__h{margin:0;font-size:10px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;}' +
    '#s3dest .s3d__sub{margin:8px 0 24px;color:#6E6E6E;font-size:12.5px;line-height:1.65;}' +
    '#s3dest select{all:unset;box-sizing:border-box;display:block;width:100%;' +
    'border-bottom:1px solid #0A0A0A;padding:9px 0 11px;font-family:inherit;font-size:17px;' +
    'cursor:pointer;background:transparent;color:#0A0A0A;}' +
    '#s3dest .s3d__note{margin:18px 0 0;color:#6E6E6E;font-size:12px;line-height:1.7;min-height:3.4em;}' +
    '#s3dest .s3d__go{all:unset;box-sizing:border-box;display:block;width:100%;text-align:center;' +
    'font-family:inherit;background:#0A0A0A;color:#fff;padding:15px 0;cursor:pointer;' +
    'font-size:11px;letter-spacing:.2em;text-transform:uppercase;margin-top:22px;' +
    'transition:background .25s ease;}' +
    '#s3dest .s3d__go:hover{background:#E10600;}' +
    '#s3dest .s3d__x{all:unset;cursor:pointer;position:absolute;top:14px;right:18px;color:#B0B0B0;' +
    'font-size:15px;padding:6px;transition:color .2s ease;}' +
    '#s3dest .s3d__x:hover{color:#0A0A0A;}' +
    /* 匯款頁的攔截畫面 */
    '.s3rmg{max-width:480px;}' +
    '.s3rmg__k{margin:0;font-size:10px;font-weight:700;letter-spacing:.22em;text-transform:uppercase;color:#E10600;}' +
    '.s3rmg__h{margin:14px 0 0;font-size:26px;line-height:1.25;font-weight:800;letter-spacing:-.01em;}' +
    '.s3rmg__p{margin:16px 0 0;color:#6E6E6E;font-size:13.5px;line-height:1.75;}' +
    '.s3rmg__go{all:unset;box-sizing:border-box;display:block;width:100%;text-align:center;' +
    'font-family:inherit;background:#0A0A0A;color:#fff;padding:16px 0;cursor:pointer;' +
    'font-size:11px;letter-spacing:.2em;text-transform:uppercase;margin-top:30px;' +
    'transition:background .25s ease;}' +
    '.s3rmg__go:hover{background:#E10600;}' +
    '.s3rmg__alt{all:unset;cursor:pointer;display:block;width:100%;text-align:center;' +
    'font-family:inherit;margin-top:16px;font-size:12px;color:#6E6E6E;' +
    'text-decoration:underline;text-underline-offset:3px;}' +
    '.s3rmg__alt:hover{color:#0A0A0A;}' +
    '@media (prefers-reduced-motion:reduce){#s3dest .s3d__scrim,#s3dest .s3d__sheet{transition:none;}}';

  function injectCSS() {
    if (document.getElementById('s3rg-css')) return;
    var st = document.createElement('style');
    st.id = 's3rg-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  /* ── SHIP TO：結帳前唯一的一個問題 ──────────────────────── */

  /*
    V 定版（2026-08-28）：「到結帳前的訂單確認先確認運送到的國家再到結帳畫面」。
    每次按結帳都確認一次：預選（上次選的，其次時區猜的）通常是對的＝一鍵繼續；
    同時它就是「韓國人看到 LINE Pay」那類事故的第一道防線。
    cb(res)：null＝關掉，什麼都不做；否則 {code, tw, path}。
  */
  function askDest(cb) {
    injectCSS();
    var old = document.getElementById('s3dest');
    if (old) old.remove();
    var zh = pageZh();
    var pre = activeCountry();

    var opts = '', open = false;
    for (var i = 0; i < SHIP.length; i++) {
      var r = SHIP[i];
      if (!r[3]) {
        if (open) opts += '</optgroup>';
        opts += '<optgroup label="' + (zh ? r[2] : r[1]) + '">';
        open = true;
      } else {
        opts += '<option value="' + r[0] + '"' + (r[0] === pre ? ' selected' : '') + '>' +
                (zh ? r[2] : r[1]) + '</option>';
      }
    }
    if (open) opts += '</optgroup>';

    var el = document.createElement('div');
    el.id = 's3dest';
    el.innerHTML =
      '<div class="s3d__scrim" data-s3d-x></div>' +
      '<div class="s3d__sheet" role="dialog" aria-modal="true">' +
      '<h3 class="s3d__h">' + (zh ? '寄送國家' : 'Ship to') + '</h3>' +
      '<p class="s3d__sub">' + (zh ? '確認收件國家，我們帶你到對應的結帳。' :
        'Confirm your delivery country to continue to checkout.') + '</p>' +
      '<select class="s3d__sel">' + opts + '</select>' +
      '<p class="s3d__note"></p>' +
      '<button type="button" class="s3d__go">' + (zh ? '繼續' : 'Continue') + ' →</button>' +
      '<button type="button" class="s3d__x" data-s3d-x aria-label="' + (zh ? '關閉' : 'Close') + '">×</button>' +
      '</div>';

    var sel = el.querySelector('.s3d__sel');
    var note = el.querySelector('.s3d__note');
    function paintNote() {
      note.textContent = sel.value === 'TW'
        ? (zh ? '超商取貨或宅配・LINE Pay 或銀行轉帳・台灣免運。'
              : 'Convenience store pickup or home delivery. LINE Pay or bank transfer. Free shipping in Taiwan.')
        : (zh ? '國際宅配・PayPal・任兩件免運。標價含稅。'
              : 'Worldwide delivery. PayPal. Free shipping on any two items, tax included.');
    }
    paintNote();
    sel.addEventListener('change', paintNote);

    function close(cb2) {
      el.classList.remove('is-in');
      setTimeout(function () { el.remove(); if (cb2) cb2(); }, 300);
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-s3d-x]')) close(function () { cb(null); });
    });
    el.querySelector('.s3d__go').addEventListener('click', function () {
      var c = sel.value;
      set(DKEY, c);
      close(function () {
        cb({ code: c, tw: c === 'TW', path: c === 'TW' ? '' : (MKT[ship()[c]] || MKT.intl) });
      });
    });

    /* 監聽全部接好才掛進畫面——順序反過來，中途一出錯就是按不掉的遮罩 */
    document.body.appendChild(el);
    reveal(el);
  }

  /* ── 匯款頁的自我防衛 ───────────────────────────────────── */

  /*
    匯款頁＝台灣專用（超商、LINE Pay、轉帳、台灣手機格式）。路由永遠會被繞過
    （直接連結、上一頁、書籤、頁面快取），所以這一頁自己再擋一次。
    2026-08-27 V 把自己設成韓國，站在這頁看著 LINE Pay——這道防線因此而生。
  */
  function guardRemit() {
    var sec = document.querySelector('.s3rm');
    if (!sec) return;
    if (activeCountry() === 'TW') return;
    if (document.getElementById('s3rmg')) return;
    injectCSS();

    var zh = pageZh();
    var d = destination();
    var cname = nameOf(d.code, zh);
    var wrap = sec.querySelector('.s3rm__wrap') || sec;
    for (var i = 0; i < wrap.children.length; i++) wrap.children[i].hidden = true;

    var box = document.createElement('div');
    box.id = 's3rmg';
    box.className = 's3rmg';
    box.innerHTML =
      '<p class="s3rmg__k">' + (zh ? '這個結帳頁是台灣專用' : 'Taiwan checkout') + '</p>' +
      '<h2 class="s3rmg__h">' + (zh ? '你的寄送地是' : 'You are shipping to') + ' ' + cname + '</h2>' +
      '<p class="s3rmg__p">' +
      (zh ? '超商取貨、LINE Pay 與銀行轉帳只提供給台灣訂單。寄到' + cname +
            '請走國際結帳，付款方式是 PayPal。'
          : 'Convenience store pickup, LINE Pay and bank transfer are for orders inside Taiwan. ' +
            'Orders to ' + cname + ' go through international checkout, paid with PayPal.') +
      '</p>' +
      '<button type="button" class="s3rmg__go" data-s3rmg-go>' +
      (zh ? '前往國際結帳' : 'Continue to international checkout') + '</button>' +
      '<button type="button" class="s3rmg__alt" data-s3rmg-tw>' +
      (zh ? '我要改成寄到台灣' : 'Ship to Taiwan instead') + '</button>';

    box.querySelector('[data-s3rmg-go]').addEventListener('click', function () {
      goCountry(d.code, d.path);
    });
    box.querySelector('[data-s3rmg-tw]').addEventListener('click', function () {
      set(DKEY, 'TW');
      location.reload();
    });

    wrap.appendChild(box);
  }

  /* ── 綁定 ───────────────────────────────────────────────── */

  function bind() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      /* 保底：就算建層時中途出錯、局部監聽沒接上，點背景或 × 永遠關得掉 */
      var dx = e.target.closest('[data-s3d-x]');
      if (dx) {
        var pd = document.getElementById('s3dest');
        if (pd) { pd.classList.remove('is-in'); setTimeout(function () { pd.remove(); }, 300); }
        return;
      }

      /* 購物車（頁面與抽屜）的結帳鈕：先確認寄送國家。商品頁那顆是
         <button data-s3bt-open>，它自己的腳本會問同一份 askDest。 */
      var twa = e.target.closest('a[data-s3-exit="tw"]');
      if (twa) {
        if (twa.getAttribute('aria-disabled') === 'true') return;
        e.preventDefault();
        askDest(function (res) {
          if (!res) return;
          if (res.tw) { location.href = twa.getAttribute('href'); return; }
          goCountry(res.code, res.path);
        });
        return;
      }

      var chip = e.target.closest('[data-s3cur]');
      if (chip) {
        e.preventDefault();
        active = chip.getAttribute('data-s3cur');
        set(CKEY, active);
        paint(active);
      }
    });
  }

  function run() { paint(active); routeCheckout(); }

  window.S3DEST = { ask: askDest, dest: destination, go: goCountry };

  function boot() {
    injectCSS();
    run();
    bind();
    guardRemit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Horizon 換 variant／開抽屜是抽換 DOM，新節點要再刷一次。rAF 收斂；
     run() 只動屬性，不動文字節點，不會跟 MutationObserver 互咬。 */
  document.addEventListener('variant:update', run);
  document.addEventListener('cart:update', run);
  var queued = false;
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) {
        queued = true;
        requestAnimationFrame(function () { queued = false; run(); });
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
